import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";

import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AppBar from "@material-ui/core/AppBar";
import { Grid, Typography, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@material-ui/core";

import HGSuperPayEmployees from "../hgSuperPay/HGSuperPayEmployees";
import HGSuperPayContributionHistory from "../hgSuperPay/HGSuperPayContributionHistory";
import EmployerSuperSetup from "../hgSuperPay/EmployerSuperSetup";

const HOT_PINK = "#fe0d9d";

function mapEmployerStatus(status) {
    if (!status || !status.onboarded) return { employerRegistered: false };
    const d          = status.employerData || {};
    const src        = status.employerData ? d : status;
    const addr       = d.address || {};
    const contact    = d.contact || {};
    const contactName = contact.name || {};
    const meta       = d.superApiMeta || {};
    const debit      = (meta.paymentDetails && meta.paymentDetails.directDebit && meta.paymentDetails.directDebit.bankAccount) || {};
    const refund     = meta.refundAccount || {};
    const sigPerson  = meta.contactPerson || {};
    const ddAgreement = meta.directDebitAgreement || {};
    const loadedSig  = src.digitalSignature || "";
    const loadedSigType = src.signatureType || status.signatureType || "draw";
    return {
        employerRegistered:    true,
        companyName:           src.employerName       || d.name                                          || "",
        abn:                   src.abn                                                                   || "",
        contactFirstName:      src.contactFirstName   || contactName.firstName                           || "",
        contactLastName:       src.contactLastName    || contactName.lastName                            || "",
        contactEmail:          src.contactEmail       || (contact.email && contact.email.value)          || "",
        contactMobile:         src.contactMobile      || (contact.phoneNumber && contact.phoneNumber.value) || "",
        contactAreaCode:       src.contactAreaCode    || src.areaCode || sigPerson.areaCode              || "",
        contactTelephone:      src.contactPhone       || sigPerson.telephone                             || "",
        signatoryName:         src.signatoryName      || sigPerson.signatoryName  || status.signatoryName  || "",
        signatoryPosition:     src.signatoryPosition  || sigPerson.signatoryPosition || status.signatoryPosition || "",
        regStreet:             src.addressLine1       || addr.addressLine1                               || "",
        regSuburb:             src.suburb             || addr.suburb                                     || "",
        regState:              src.state              || addr.state                                      || "",
        regPostcode:           src.postcode           || addr.postcode                                   || "",
        contribBSB:            src.bankBsb            || debit.bsb                                       || "",
        contribAccountNumber:  src.bankAccountNumber  || debit.accountNumber                             || "",
        contribAccountName:    src.bankAccountName    || debit.accountName                               || "",
        refundBSB:             src.refundBsb          || refund.bsb                                      || "",
        refundAccountNumber:   src.refundAccountNumber || refund.accountNumber                           || "",
        refundAccountName:     src.refundAccountName  || refund.accountName                              || "",
        directDebitAgreed:       src.agreedToTerms      || ddAgreement.agreedToTerms || !!status.agreedAt || false,
        sameAsContrib:           src.sameAsDirectDebit !== undefined ? src.sameAsDirectDebit : false,
        signatureDataUrl:        loadedSigType === "upload" ? loadedSig : loadedSig,
        onboardedAtClearingHouse: !!(status.onboardedAtClearingHouse ?? (status.employerData && status.employerData.onboardedAtClearingHouse)),
        detailsSyncedAtClearingHouse: status.detailsSyncedAtClearingHouse ?? (status.employerData && status.employerData.detailsSyncedAtClearingHouse) ?? null,
        get verifiedAtClearingHouse() {
            const synced = this.detailsSyncedAtClearingHouse;
            return this.onboardedAtClearingHouse && (synced === "true" || synced === "NA");
        },
    };
}

const SHIMMER_CSS = "@keyframes hgShimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}";
const SHIMMER_STYLE = {
    borderRadius: 6,
    background: "linear-gradient(90deg,#e9eaee 25%,#f3f4f6 50%,#e9eaee 75%)",
    backgroundSize: "200% 100%",
    animation: "hgShimmer 1.4s infinite",
};

const StatusCard = ({ label, value, valueColor, meta, action, loading }) => (
    <div style={{ background: "#fff", border: "1px solid #e9eaee", borderRadius: 14, padding: 18, height: "100%" }}>
        <div style={{ fontSize: 12, textTransform: "uppercase", letterSpacing: ".04em", color: "#6b7280", marginBottom: 8 }}>
            {label}
        </div>
        {loading ? (
            <div>
                <div style={{ ...SHIMMER_STYLE, width: "55%", height: 22, marginBottom: 8 }} />
                <div style={{ ...SHIMMER_STYLE, width: "75%", height: 13 }} />
            </div>
        ) : (
            <Fragment>
                <div style={{ fontSize: 18, fontWeight: 700, color: valueColor || "#1f2430" }}>{value}</div>
                {meta && <div style={{ fontSize: 12.5, color: "#6b7280", marginTop: 6 }}>{meta}</div>}
                {action && <div style={{ marginTop: 12 }}>{action}</div>}
            </Fragment>
        )}
    </div>
);

class VenueHGSuperPayTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabValue: props.initialTab || 0,
            employerRegistered: false,
            employerOnboardedAtClearingHouse: false,
            employerName: "",
            employerInitialValues: null,
            employerLoading: true,
            registrationConfirmOpen: false,
        };
    }

    componentDidMount() {
        const { profileId } = this.props;

        if (profileId) {
            this.props.financialProfileStore.setType(5);
            if (this.props.financialProfileStore.paymentType === null) {
                this.props.financialProfileStore.loadInitialData(profileId);
            }
            this.props.hgSuperPayAddonStore.loadAddonStatusForProfile(profileId);
            this._loadEmployerStatus(profileId);
        } else {
            this.setState({ employerLoading: false });
        }
    }

    componentDidUpdate(prevProps) {
        // Only navigation changes the requested tab; store updates must preserve manual selections.
        if (prevProps.initialTab !== this.props.initialTab ||
            prevProps.navigationKey !== this.props.navigationKey) {
            this.setState({ tabValue: this.props.initialTab || 0 });
        }
    }

    _loadEmployerStatus(profileId) {
        this.setState({ employerLoading: true });
        this.props.hgSuperPayStore.getEmployerStatus(profileId)
            .then(status => {
                const mapped = mapEmployerStatus(status);
                this.setState({
                    employerLoading: false,
                    employerRegistered: mapped.employerRegistered || false,
                    employerOnboardedAtClearingHouse: mapped.verifiedAtClearingHouse || false,
                    employerName: mapped.companyName || "",
                    employerInitialValues: mapped,
                });
            })
            .catch(() => {
                this.setState({ employerLoading: false, employerInitialValues: { employerRegistered: false } });
            });
    }

    handleTabChange = (event, tabValue) => {
        this.setState({ tabValue });
        if (tabValue === 1) {
            const { profileId } = this.props;
            if (profileId) {
                this._loadEmployerStatus(profileId);
            }
        }
    };

    handleEmployerStatusChange = (registered, name) => {
        this.setState({ employerRegistered: registered, employerName: name });
    };

    handleRegister = async (formState) => {
        const { profileId } = this.props;
        const payload = {
            profileId,
            employerName:              formState.companyName,
            abn:                       formState.abn,
            employerArrangement:       "DEFAULT",
            location:                  "AU",
            contributionsEnabled:      true,
            employeeServicesEnabled:   true,
            singleTouchPayrollEnabled: false,
            splitMultiEmployerBatch:   false,
            contactFirstName:          formState.contactFirstName,
            contactMiddleName:         "",
            contactLastName:           formState.contactLastName,
            contactEmail:              formState.contactEmail,
            contactMobile:             formState.contactMobile,
            contactPhone:              formState.contactTelephone,
            contactAreaCode:           formState.contactAreaCode,
            signatoryName:             formState.signatoryName,
            signatoryPosition:         formState.signatoryPosition,
            addressType:               "POSTAL",
            addressLine1:              formState.regStreet,
            addressLine2:              "",
            addressLine3:              "",
            suburb:                    formState.regSuburb,
            postcode:                  formState.regPostcode,
            state:                     formState.regState,
            bankAccountName:           formState.contribAccountName,
            bankBsb:                   formState.contribBSB,
            bankAccountNumber:         formState.contribAccountNumber,
            sameAsDirectDebit:         formState.sameAsContrib,
            refundBsb:                 formState.refundBSB,
            refundAccountName:         formState.refundAccountName,
            refundAccountNumber:       formState.refundAccountNumber,
            agreedToTerms:             formState.directDebitAgreed,
            agreedAt:                  new Date().toISOString(),
            digitalSignature:          formState.signatureDataUrl || "",
            signatureType:             formState.signatureDataUrl ? "upload" : "draw",
            legalAgreements: {
                termsAndConditions:           true,
                privacyPolicy:                true,
                directDebitServiceAgreement:  true,
                masterServiceAgreement:       true,
            },
        };
        const isNewRegistration = !this.state.employerRegistered;
        await this.props.hgSuperPayStore.onboardEmployer(payload, !isNewRegistration);
        this.setState({
            employerRegistered: true,
            employerName: formState.companyName,
            registrationConfirmOpen: true,
        });
        if (profileId) this._loadEmployerStatus(profileId);
    };

    handleCloseRegistrationConfirm = () => {
        this.setState({ registrationConfirmOpen: false });
    };

    handleActivateAddon = async () => {
        try {
            const { profileId } = this.props;
            sessionStorage.setItem("venueHgSuperPayProfileId", profileId || "");
            const response = await this.props.hgSuperPayAddonStore.startCheckoutForProfile(profileId);
            if (response && response.checkoutUrl) {
                window.open(response.checkoutUrl, "_blank");
            }
        } catch (e) {
            let message;
            if (e && e.status === 409) {
                message = "You already have an active HG Super Pay subscription.";
            } else if (e && e.status === 404) {
                message = "Billing must be set up before activating this add-on.";
            } else {
                message = "Failed to start checkout. Please try again.";
            }
            this.props.templateStore.openSnackbar(message);
        }
    };

    renderOverview() {
        const { addonStatus, currentMonthUsage, temporaryFeeAmountFormatted } = this.props.hgSuperPayAddonStore;
        const { employerRegistered, employerOnboardedAtClearingHouse, employerName, employerLoading } = this.state;

        const isLoading = addonStatus === "loading";
        const isActive = addonStatus === "active";

        const addonValue = isLoading ? "Checking…" : isActive ? "Active" : "Inactive";
        const addonColor = isLoading ? "#6b7280" : isActive ? "#15a36a" : "#6b7280";

        const quickActions = [
            { title: "Super Ledger", desc: "See what super you owe and pay it", onClick: () => this.props.history.push("/superLedgers") },
            { title: "Payments", desc: "Track submitted payments and their status", onClick: () => this.props.history.push("/payments") },
            ...(isActive ? [{ title: "Manage employees", desc: "Map sole-trader artists to HG Super Pay", onClick: () => this.setState({ tabValue: 2 }) }] : [])
        ];

        return (
            <div>
                <style>{SHIMMER_CSS}</style>
                <Grid container spacing={16}>
                    <Grid item xs={12} md={4}>
                        <StatusCard
                            label="Add-on"
                            loading={isLoading}
                            value={addonValue}
                            valueColor={addonColor}
                            meta="$1.50 ex GST per submission"
                            action={
                                !isLoading && !isActive ? (
                                    <Button
                                        variant="contained"
                                        size="small"
                                        style={{ backgroundColor: HOT_PINK, color: "#fff" }}
                                        onClick={this.handleActivateAddon}
                                    >
                                        Activate
                                    </Button>
                                ) : null
                            }
                        />
                    </Grid>
                    {isActive && (
                        <Grid item xs={12} md={4}>
                            <StatusCard
                                label="Employer"
                                loading={employerLoading}
                                value={
                                    !employerRegistered ? "Not registered"
                                    : employerOnboardedAtClearingHouse ? "Active"
                                    : "Submitted - Awaiting Verification"
                                }
                                valueColor={
                                    !employerRegistered ? "#6b7280"
                                    : employerOnboardedAtClearingHouse ? "#15a36a"
                                    : "#1976d2"
                                }
                                meta={employerRegistered ? employerName : null}
                                action={
                                    !employerRegistered ? (
                                        <Button size="small" style={{ color: HOT_PINK }} onClick={() => this.setState({ tabValue: 1 })}>
                                            Set up now
                                        </Button>
                                    ) : (
                                        <Button size="small" style={{ color: HOT_PINK }} onClick={() => this.setState({ tabValue: 1 })}>
                                            Edit
                                        </Button>
                                    )
                                }
                            />
                        </Grid>
                    )}
                    {isActive && (
                        <Grid item xs={12} md={4}>
                            <StatusCard
                                label="This month"
                                loading={isLoading}
                                value={`${currentMonthUsage || 0} submission${(currentMonthUsage || 0) !== 1 ? "s" : ""}${temporaryFeeAmountFormatted ? ` ≈ ${temporaryFeeAmountFormatted}` : ""}`}
                                meta={`Billed 5th of next month`}
                            />
                        </Grid>
                    )}
                </Grid>

                <Typography variant="subheading" style={{ fontWeight: 700, margin: "26px 0 12px" }}>
                    Quick actions
                </Typography>
                <Grid container spacing={16}>
                    {quickActions.map((qa) => (
                        <Grid item xs={12} md={4} key={qa.title}>
                            <div
                                onClick={qa.onClick}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: 10,
                                    background: "#fff",
                                    border: "1px solid #e9eaee",
                                    borderRadius: 12,
                                    padding: "16px 18px",
                                    cursor: "pointer"
                                }}
                            >
                                <span>
                                    <span style={{ fontWeight: 600, fontSize: 14.5, display: "block" }}>{qa.title}</span>
                                    <span style={{ fontSize: 12.5, color: "#6b7280" }}>{qa.desc}</span>
                                </span>
                                <span style={{ color: HOT_PINK, fontSize: 20 }}>→</span>
                            </div>
                        </Grid>
                    ))}
                </Grid>
            </div>
        );
    }

    renderNotActive() {
        return (
            <div style={{ textAlign: "center", padding: "48px 24px", color: "#6b7280" }}>
                <Typography variant="title" style={{ fontWeight: 700, color: "#1f2430", marginBottom: 8 }}>
                    HG Super Pay Not Active
                </Typography>
                <Typography variant="body1" style={{ color: "#6b7280" }}>
                    Activate the HG Super Pay add-on from the Overview tab to set up and manage superannuation payments.
                </Typography>
            </div>
        );
    }

    renderAccessDenied() {
        return (
            <div style={{ textAlign: "center", padding: "60px 24px", color: "#6b7280" }}>
                <Typography variant="title" style={{ fontWeight: 700, color: "#1f2430", marginBottom: 8 }}>
                    Financial Access Required
                </Typography>
                <Typography variant="body1" style={{ color: "#6b7280", maxWidth: 440, margin: "0 auto" }}>
                    You need financial permission on this venue profile to manage HG Super Pay.
                </Typography>
            </div>
        );
    }

    renderNotEligible() {
        const { profileId } = this.props;
        return (
            <div style={{ textAlign: "center", padding: "60px 24px", color: "#6b7280" }}>
                <Typography variant="title" style={{ fontWeight: 700, color: "#1f2430", marginBottom: 8 }}>
                    HG Super Pay Not Selected
                </Typography>
                <Typography variant="body1" style={{ color: "#6b7280", maxWidth: 440, margin: "0 auto" }}>
                    To use HG Super Pay, set your super payment method to <strong>HG Super Pay</strong> in{" "}
                    <a
                        href={`/venues/${profileId}/edit/financial`}
                        style={{ color: HOT_PINK }}
                        onClick={e => {
                            e.preventDefault();
                            this.props.history.push(`/venues/${profileId}/edit/financial`);
                        }}
                    >
                        Financial settings
                    </a>{" "}
                    and save, then return to this tab.
                </Typography>
            </div>
        );
    }

    render() {
        const { tabValue } = this.state;
        const { profileId } = this.props;
        const { addonStatus } = this.props.hgSuperPayAddonStore;
        const { paymentType } = this.props.financialProfileStore;

        const isLoading = addonStatus === "loading";
        const isActive = addonStatus === "active";

        const { currentUser } = this.props.userStore;
        const venueProfile = this.props.profileStore.profile;
        const currentOwnProfile = this.props.profileStore.getCurrentProfile();
        const isVenueOwner = currentOwnProfile && String(currentOwnProfile.id) === String(profileId);
        const memberEntry = venueProfile?.members?.find(m => m.userId === currentUser?.sub);
        const hasFinancialPermission = isVenueOwner || memberEntry?.financial === true;

        if (!hasFinancialPermission) {
            return this.renderAccessDenied();
        }

        const badge =
            addonStatus === "loading"
                ? { label: "Checking…", color: "#6b7280", bg: "#eef0f3" }
                : addonStatus === "active"
                ? { label: "Active", color: "#15a36a", bg: "#e8f7ef" }
                : { label: "Inactive", color: "#6b7280", bg: "#eef0f3" };

        return (
            <Fragment>
                <Paper style={{ position: "relative", overflow: "hidden" }}>
                    <AppBar position="static" elevation={2} style={{ backgroundColor: "#3A3B3D" }}>
                        <Tabs
                            value={isActive ? tabValue : 0}
                            onChange={this.handleTabChange}
                            indicatorColor="primary"
                            textColor="secondary"
                            scrollable
                            scrollButtons="off"
                            classes={{ root: "tabs-root", indicator: "tabs-indicator" }}
                        >
                            <Tab label="Overview" classes={{ selected: "tab-selected" }} />
                            {isActive && <Tab label="Employer" classes={{ selected: "tab-selected" }} />}
                            {isActive && <Tab label="Employees" classes={{ selected: "tab-selected" }} />}
                            {isActive && <Tab label="Contribution History" classes={{ selected: "tab-selected" }} />}
                        </Tabs>
                    </AppBar>

                    <Paper className="org-paper-form" style={{ borderRadius: "0px 0px 2px 2px", position: "relative", padding: 20 }}>
                        {tabValue === 0 && this.renderOverview()}
                        {tabValue === 1 &&
                            (isActive ? (
                                this.state.employerLoading ? (
                                    <div style={{ padding: 32, textAlign: "center", color: "#6b7280" }}>Loading employer details…</div>
                                ) : (
                                    <EmployerSuperSetup
                                        initialValues={this.state.employerInitialValues || { employerRegistered: false }}
                                        onStatusChange={this.handleEmployerStatusChange}
                                        onRegister={this.handleRegister}
                                    />
                                )
                            ) : isLoading ? null : (
                                this.renderNotActive()
                            ))}
                        {tabValue === 2 &&
                            (isActive ? (
                                <HGSuperPayEmployees
                                    embedded
                                    employerRegistered={this.state.employerOnboardedAtClearingHouse}
                                    profileId={profileId}
                                />
                            ) : isLoading ? null : (
                                this.renderNotActive()
                            ))}
                        {tabValue === 3 &&
                            (isActive ? (
                                <HGSuperPayContributionHistory profileId={profileId} />
                            ) : isLoading ? null : (
                                this.renderNotActive()
                            ))}
                    </Paper>
                </Paper>

                <Dialog open={this.state.registrationConfirmOpen} onClose={this.handleCloseRegistrationConfirm}>
                    <DialogTitle style={{ backgroundColor: HOT_PINK, padding: "12px 24px" }} disableTypography>
                        <Typography variant="title" style={{ color: "#fff", fontWeight: 700 }}>
                            Registration Submitted
                        </Typography>
                    </DialogTitle>
                    <DialogContent style={{ paddingTop: 20 }}>
                        <DialogContentText>
                            Your employer registration application has been submitted. Approval can take between 24 to 48 hours. We will email you once the process is complete.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.handleCloseRegistrationConfirm}
                            style={{ backgroundColor: HOT_PINK, color: "#fff" }}
                            variant="contained"
                        >
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </Fragment>
        );
    }
}

export default inject(
    "profileStore",
    "templateStore",
    "financialProfileStore",
    "hgSuperPayAddonStore",
    "hgSuperPayStore",
    "hgBillingStore",
    "userStore"
)(withRouter(observer(VenueHGSuperPayTab)));
